import { useCallback } from 'react'
import { useStoreModals } from '../../modals/use-store-modals'
import { ExternalPaywallUrlParams } from '../../../types'

export interface UseExternalPaywall {
  onClickPaywall: (params: ExternalPaywallUrlParams) => void
}

export const useExternalPaywall = (): UseExternalPaywall => {
  const {
    modalExternalPaywall: { onOpen }
  } = useStoreModals()

  const onClickPaywall = useCallback((params: ExternalPaywallUrlParams) => {
    onOpen(params)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    onClickPaywall
  }
}
